import { DASHBOARD_PATH, LOCALSTORAGES } from "@/constants/constant";
import {
  useGetListNotificationApiCallQuery,
  useGetProfileApiCallQuery,
  useGetReadStatusNotificationApiCallQuery,
  useSignInApiCallMutation,
} from "@/services/api/auth/auth.api";
import { ApiError } from "@/services/api/auth/auth.type";
import { ConnectButton, useConnectModal } from "@rainbow-me/rainbowkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAccount, useAccountEffect, useConnect, useDisconnect } from "wagmi";
import BingoldLogo from "./BingoldLogo";
import { Button } from "./ui/button";
import { slice } from "viem";
import Loader from "./Loader";

interface HeaderProps {
  onLaunchApp?: () => void;
}

export default function Header({ onLaunchApp }: HeaderProps) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { address, isConnected } = useAccount();
  const { openConnectModal } = useConnectModal();

  const { disconnect } = useDisconnect();
  const [Signin, { isError, isLoading: isSigningIn }] =
    useSignInApiCallMutation();
  const loacation = useLocation();
  const location = useLocation();
  const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
  const { data: userProfile, isError: isProfileError } =
    useGetProfileApiCallQuery(undefined, {
      skip: !token,
      refetchOnMountOrArgChange: true,
    });

  const handleDisconnect = () => {
    disconnect();
    localStorage.removeItem("shouldConnectSocket");
    localStorage.removeItem("redeemCode");
    localStorage.removeItem(LOCALSTORAGES.TOKEN);
    navigate(DASHBOARD_PATH.ROOT);
  };

  useEffect(() => {
    if (isProfileError) {
      handleDisconnect();
    }
  }, [isProfileError]);

  // Detect if coming from individual campaign route
  const intendedPath = (location.state as { from?: string })?.from;
  const isFromIndividualCampaign =
    intendedPath &&
    intendedPath.startsWith("/dashboard/individual-campaign/") &&
    intendedPath !== "/dashboard/individual-campaign/";
  const refferal = location.pathname.split("/").includes("ref")
    ? loacation?.pathname?.split("/").slice(-1)[0]
    : false;

  const handleLogin = async (address?: string) => {
    try {
      const response = await Signin({
        walletAddress: address,
        ...(refferal && { code: refferal }),
      }).unwrap();

      if (response.responseCode === 200) {
        localStorage.setItem(LOCALSTORAGES.TOKEN, response.result.token);
        toast.success(response.responseMessage);
        if (isFromIndividualCampaign) {
          navigate(intendedPath!, { replace: true });
        } else {
          navigate(DASHBOARD_PATH.ALL_CAMPAIGNS, { replace: true });
        }
      } else {
        toast.error(response.responseMessage);
      }
    } catch (error) {
      const err = error as FetchBaseQueryError;
      const errorData = err.data as ApiError;
      toast.error(errorData?.responseMessage || "Error signing in");
      console.error("Error signing in:", error);
      disconnect();
    }
    // const response = await fetch(`${API_BASE_URL}/api/v1/user/login`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({ walletAddress: address }),
    // });

    // console.log(response);
  };

  const handleWalletConnect = () => {
    if (openConnectModal) {
      openConnectModal();
    }
  };

  useAccountEffect({
    onConnect({ address }) {
      const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
      if (refferal && address) {
        if (!token) {
          handleLogin(address);
        }
        return; // skip the normal login case
      }
      if (!token && address) {
        handleLogin(address);
      }
    },
    onDisconnect() {
      localStorage.removeItem(LOCALSTORAGES.TOKEN);
      navigate("/");
    },
  });

  // useEffect(() => {
  //   const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
  //   if (isConnected && address) {
  //     if (!token) {
  //       handleLogin();
  //     }
  //   }
  // }, [address]);

  // useEffect(() => {
  //   const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
  //   if (refferal && address) {
  //     handleLogin();
  //   }
  // }, [refferal, loacation.pathname, address]);

  // useEffect(() => {
  //   const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
  //   if (!token && address) {
  //     handleLogin();
  //   }
  // }, [address]);

  // useEffect(() => {
  //   if (refferal) {
  //     handleLogin();
  //   }
  // }, [refferal, address]);

  // useEffect(() => {
  //   if (isDisconnected) {
  //     localStorage.removeItem(LOCALSTORAGES.TOKEN); // or sessionStorage
  //   }
  // }, [isDisconnected]);

  const dailyVist = async () => {
    const response = await fetch(`https://aiiongold.com/api/v2/daily-visit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({ walletAddress: address }),
    });

    const data = await response.json();
    console.log(data);

    // console.log(response);
  };

  useEffect(() => {
    dailyVist();
  }, []);

  return (
    <>
      {isSigningIn && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100]">
          <Loader size="lg" text="Signing you in..." />
        </div>
      )}
      <header className="fixed top-0 w-full bg-black/90 backdrop-blur-md border-b border-yellow-500/20 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <BingoldLogo />

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center justify-center space-x-8">
              <a
                href="#home"
                className="text-white hover:text-yellow-400 transition-colors"
              >
                Home
              </a>
              <a
                href="#airdrop"
                className="text-white hover:text-yellow-400 transition-colors"
              >
                Campaigns
              </a>
              <a
                href="#features"
                className="text-white hover:text-yellow-400 transition-colors"
              >
                How It Works
              </a>
              <a
                href="#about"
                className="text-white hover:text-yellow-400 transition-colors"
              >
                About
              </a>
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center space-x-4">
              {/* <Button
              variant="outline"
              className="border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black"
              onClick={onLaunchApp}
            >
              Launch App
            </Button> */}

              <Link
                to={"https://skynet.certik.com/projects/bingold"}
                target="_blank"
              >
                <img src="/audit.png" alt="" className="max-w-52" />
              </Link>

              {/* <div className="mt-2">
              </div> */}
              {token ? (
                <Button
                  onClick={() => navigate(DASHBOARD_PATH.ALL_CAMPAIGNS)}
                  variant="default"
                >
                  Dashboard
                </Button>
              ) : (
                <ConnectButton showBalance={true} chainStatus="none" />
              )}

              {/* <Button
              className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700"
              onClick={onLaunchApp}
            >
              Connect Wallet
            </Button> */}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-yellow-500/20">
              <nav className="flex flex-col space-y-4 mt-4">
                <a
                  href="#home"
                  className="text-white hover:text-yellow-400 transition-colors"
                >
                  Home
                </a>
                <a
                  href="#airdrop"
                  className="text-white hover:text-yellow-400 transition-colors"
                >
                  Campaigns
                </a>
                <a
                  href="#features"
                  className="text-white hover:text-yellow-400 transition-colors"
                >
                  How It Works
                </a>
                <a
                  href="#about"
                  className="text-white hover:text-yellow-400 transition-colors"
                >
                  About
                </a>
                <div className="flex flex-col space-y-2 pt-4">
                  {/* <Button
                  variant="outline"
                  className="border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black"
                  onClick={onLaunchApp}
                >
                  Launch App
                </Button> */}

                  {token ? (
                    <Button
                      onClick={() => navigate(DASHBOARD_PATH.ALL_CAMPAIGNS)}
                      variant="default"
                    >
                      Dashboard
                    </Button>
                  ) : (
                    <Button
                      className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 cursor-pointer"
                      onClick={handleWalletConnect}
                    >
                      Connect Wallet
                    </Button>
                  )}
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      <div className="fixed bottom-4 right-4 bg-[#000] border-2 border-gray-600 text-white p-4 rounded-xl shadow-lg z-50 widget_mobile">
        <div className="flex gap-5 items-center">
          <img src="/bingold_logo.png" alt="Bigod Token" className="h-16" />
          <div>
            <div className="flex gap-3 items-center">
              <h4 className="text-xl font-semibold">Daily Visits</h4>
              <span className="flex items-center gap-2">
                <span className="relative w-3 h-3">
                  <span className="absolute top-0 left-0 w-3 h-3 bg-red-600 rounded-full animate-ping"></span>
                  <span className="absolute top-0 left-0 w-3 h-3 bg-red-600 rounded-full"></span>
                </span>
                <span className="text-red-600 font-semibold text-xs">LIVE</span>
              </span>
            </div>
            <p className="text-lg font-bold text-[#00A2F9]">26161</p>
          </div>
        </div>
      </div>
    </>
  );
}
